import type { ReactNode } from 'react';
import { cn } from '@parrot-software/utils';

interface PageContentProps {
  children: ReactNode;
  className?: string;
}

/**
 * PageContent - Content wrapper shared by every subscriptions route.
 *
 * Owns the top offset that pushes the page below the mobile `AppFrame` header. That header
 * only renders under the MUI `sm` breakpoint (< 600px), so the offset is scoped to
 * `max-[599px]` to avoid extra spacing on tablet/desktop. It also applies the domain's Inter
 * font, which every nested element inherits.
 *
 * Caps the content at 1400px and centers it so it does not stretch edge to edge on wide
 * screens. A page that needs the full workspace passes `max-w-none`.
 *
 * Pages pass their own spacing through `className`.
 *
 * @param {PageContentProps} props - Component properties
 * @returns {React.ReactElement} Page content wrapper
 *
 * @example
 * <PageContent className="min-w-0">
 *   <SubscriptionsListContent />
 * </PageContent>
 */
export const PageContent = ({ children, className }: PageContentProps) => (
  <div className={cn('mx-auto w-full max-w-[1400px] font-sans max-[599px]:mt-14', className)}>{children}</div>
);
